var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48726 26.5652C2.70953 23.035 5.51431 23.7369 7.26068 23.035C4.5194 20.5314 0 23.3598 0 27.1728C0 30.9859 4.07487 32.7248 7.26068 31.7192C10.4465 30.7135 19.5276 25.0987 22.0572 25.0987C24.0809 25.0987 24.5939 26.4814 24.5974 27.1728C24.5974 30.7869 20.8612 30.6741 19.5276 31.0278C21.1258 32.0334 27 32.4629 27 27.1728C27 22.9407 23.7048 22.0084 22.0572 22.0713C17.8024 22.0713 12.2775 26.45 7.26068 28.4718C3.38267 29.8043 2.46256 27.756 2.48726 26.5652Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.537 2.94361C16.109 2.94361 16.5641 6.55765 15.6644 9.02986C16.3136 8.64925 17.6119 7.66843 17.6119 5.05966C17.6119 2.00043 15.3893 0 13.537 0C12.1823 0.00361991 9.47275 1.40333 9.47275 5.05966C9.39866 6.02702 9.68655 8.17537 11.4308 9.02986C10.9651 7.83528 10.2666 2.94361 13.537 2.94361Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6217 17.1901C10.4147 17.1901 4.51939 13.9427 7.33476 6.40039C6.44216 6.54356 4.65698 7.86905 4.65698 12.0257C4.65698 17.2216 8.54134 20.5318 13.6217 20.5318C18.7021 20.5318 22.3324 17.1901 22.3324 12.0257C22.3324 7.89419 20.5754 6.58771 19.697 6.45091C22.7558 13.9742 16.7546 17.1901 13.6217 17.1901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.f9da8c6affade8943782830cb554b551.svg";
export { ForwardRef as ReactComponent };